<template>
  <div class="col-12">
    <div class="row">
      <div class="col-12 pt-0 px-0">
        <div class="col-12 py-1 px-4">
          <h3 class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold">
            {{ typeMaster.name }}
          </h3>
          <div class="row">
            <div class="form-group col-12 col-md-8 mb-0 mb-md-4 px-0">
              <div class="d-flex align-items-end">
                <div class="w-50 pr-2">
                  <label for="">Búsqueda</label>
                  <input
                    type="text"
                    placeholder="Buscar"
                    class="form-control form-control-sm mt-1 mb-2"
                    v-model="searchQuery"
                    @keyup="loadElements()"
                  />
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 p-0 mb-3 pt-md-4 pl-md-5">
              <div class="d-flex justify-content-md-end pt-md-2 pt-0">
                <button
                  type="button"
                  class="text-white mb-0 mt-md-0 mt-2 btn bg-primary border-0"
                  @click.prevent="goNew()"
                >
                  Agregar {{ typeMaster.name }}
                </button>
              </div>
            </div>
          </div>

          <div class="table-responsive card">
            <table class="table table-sm table-hover">
              <thead class="thead-light">
                <tr>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">id</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Nombre</div>
                  </th>
                  <th class="mb-0" scope="col">
                    <div class="font-weight-bold text-center">Acciones</div>
                  </th>
                  <th class="d-none"></th>
                </tr>
              </thead>
              <tbody class=" ">
                <tr
                  class=""
                  v-for="item in data"
                  :key="item.id"
                  style="cursor: pointer; height: 38px"
                >
                  <td class="text-center">{{ item.id }}</td>

                  <td class="text-center">
                    {{ item.name }}
                  </td>

                  <td class="text-center">
                    <div class="d-flex justify-content-center w-100">
                      <Tooltip
                        :text="item.active === 1 ? 'Desactivar' : 'Activar'"
                      >
                        <button
                          class="btn border-0 mx-1 p-2"
                          :class="{
                            'bg-secondary': item.active === 0,
                            'bg-success': item.active === 1
                          }"
                          @click="changeStatus(item.id, item.active)"
                        >
                          <i
                            v-if="item.active === 1"
                            class="bi bi-check2-circle text-white d-flex justify-content-center align-items-center"
                          ></i>
                          <i
                            v-else
                            class="bi bi-eye-slash text-white d-flex justify-content-center align-items-center"
                          ></i>
                        </button>
                      </Tooltip>
                      <Tooltip text="Editar">
                        <button
                          class="btn bg-warning border-0 mx-1 p-2"
                          @click="goEdit(item.id)"
                        >
                          <i
                            class="bi bi-pencil-square text-white d-flex justify-content-center align-items-center"
                          ></i>
                        </button>
                      </Tooltip>
                      <Tooltip text="Eliminar">
                        <button
                          class="btn bg-danger border-0 mx-1 p-2 h-100"
                          @click="changeStatus(item.id, item.active, true)"
                        >
                          <i
                            class="bi-trash3-fill text-white d-flex justify-content-center align-items-center"
                          ></i>
                        </button>
                      </Tooltip>
                    </div>
                  </td>
                  <td class="d-none"></td>
                </tr>
              </tbody>
            </table>
            <!--Paginacion-->
            <div class="d-flex justify-content-center">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === 1 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="changePage(currentPage - 1)"
                      aria-label="Previous"
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li class="page-item" v-for="page in totalPages" :key="page">
                    <a
                      class="page-link"
                      :class="{
                        'bg-primary ': page == currentPage,
                        'text-white': page === currentPage
                      }"
                      href="#"
                      @click.prevent="changePage(page)"
                      >{{ page }}</a
                    >
                  </li>
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === totalPages }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="changePage(currentPage + 1)"
                      aria-label="Next"
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name: 'MasterList',
  props: {
    typeMaster: {
      type: Object,
      required: true
    }
  },
  watch: {
    typeMaster: {
      handler(newVal, oldVal) {
        this.loadElements()
      },
      deep: true
    }
  },
  data() {
    return {
      data: [],
      searchQuery: '',
      currentPage: 1,
      totalPages: 0,
      limit: 20,

      buttonNewUrl: 'MemberNew'
    }
  },
  methods: {
    ...mapActions(['getData', 'changeStatusData', 'createData', 'updateData']),

    async loadElements(page = 1) {
      if (!this.typeMaster || !this.typeMaster.url_api) {
        console.warn('typeMaster.name is required')
        return
      }
      const form = {
        url: `${this.typeMaster.url_api}/all`,
        params: {
          query: this.searchQuery,
          page: page,
          limit: this.limit
        }
      }

      await this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.data = response.data.data.reverse()
            this.currentPage = response.data.meta.current_page
            this.totalPages = response.data.meta.last_page
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    changeStatus(id, active, isDelete = false) {
      let status
      let message
      if (isDelete) {
        status = 2
        message = '¿Estás seguro de eliminar este valor?'
      } else {
        status = active === 0 ? 1 : 0
        message =
          active === 0
            ? '¿Estás seguro de activar este valor?'
            : '¿Estás seguro de desactivar este valor?'
      }

      const form = {
        url: `${this.typeMaster.url_api}/change_status`,
        id,
        status
      }

      Swal.fire({
        title: 'Advertencia',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200 && status === 0) {
                Swal.fire({
                  icon: 'success',
                  title: '¡Éxito!',
                  text: 'El estado del usuario ha sido desactivado'
                })
                this.loadElements()
              } else if (response.code === 200 && status === 1) {
                Swal.fire({
                  icon: 'success',
                  title: '¡Éxito!',
                  text: 'El estado del usuario ha sido activado'
                })
                this.loadElements()
              } else if (response.code === 200 && status === 2) {
                Swal.fire({
                  icon: 'success',
                  title: '¡Éxito!',
                  text: 'El usuario ha sido eliminado'
                })
                this.loadElements()
              }
            })
            .catch((error) => {
              console.error(error)
            })
        }
      })
    },

    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      this.loadElements(page)
    },
    async goNew() {
      const { value: name } = await Swal.fire({
        title: `Agregar Nuevo ${this.typeMaster.name}`,
        input: 'text',
        inputPlaceholder: `Ingrese el nombre del nuevo ${this.typeMaster.name}`,
        showCancelButton: true,
        confirmButtonText: 'Agregar',
        cancelButtonText: 'Cancelar',
        inputValidator: (value) => {
          if (!value) {
            return 'Este campo no puede quedar vacío!'
          }
        }
      })

      if (name) {
        const result = await Swal.fire({
          title: '¿Está seguro?',
          text: `¿Desea agregar este ${this.typeMaster.name}?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí, agregarlo',
          cancelButtonText: 'Cancelar'
        })

        if (result.isConfirmed) {
          const form = {
            url: `${this.typeMaster.url_api}/save`,
            data: { name }
          }

          try {
            const response = await this.createData(form)
            if (response.code === 200) {
              Swal.fire('¡Éxito!', 'El maestro ha sido creado.', 'success')
              this.loadElements() // Reload the list to include the new item
            }
          } catch (error) {
            console.error(error)
            Swal.fire('Error', 'Ocurrió un error al crear el maestro.', 'error')
          }
        }
      }
    },

    async goEdit(id) {
      const currentMaster = this.data.find((item) => item.id === id)
      const { value: name } = await Swal.fire({
        title: `Modificar ${this.typeMaster.name}`,
        input: 'text',
        inputLabel: `Nuevo valor para: ${currentMaster.name}`,
        inputValue: currentMaster.name,
        showCancelButton: true,
        confirmButtonText: 'Actualizar',
        cancelButtonText: 'Cancelar',
        inputValidator: (value) => {
          if (!value) {
            return 'Este campo no puede quedar vacío!'
          }
        }
      })

      if (name && name !== currentMaster.name) {
        const result = await Swal.fire({
          title: '¿Está seguro?',
          text: `¿Desea modificar este ${this.typeMaster.name}?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí, modificarlo',
          cancelButtonText: 'Cancelar'
        })

        if (result.isConfirmed) {
          const form = {
            url: `${this.typeMaster.url_api}/update`,
            id,
            data: { name }
          }

          try {
            const response = await this.updateData(form)
            if (response.code === 200) {
              Swal.fire('¡Éxito!', 'El maestro ha sido modificado.', 'success')
              this.loadElements() // Reload the list to reflect the updated item
            }
          } catch (error) {
            console.error(error)
            Swal.fire(
              'Error',
              'Ocurrió un error al modificar el maestro.',
              'error'
            )
          }
        }
      }
    }
  },
  mounted() {
    this.loadElements()
  }
}
</script>
